// @flow
import * as React from 'react';
import MetaInfoToggle from './MetaInfoToggle';
import classnames from 'classnames';

type Props = {
  label: string,
  onClick: Function,
  open: boolean,
  children?: React.Node,
};

const CollapsedBlock = (props: Props) => {
  const { label, onClick, open = false, children } = props;
  const containerClassName = classnames({
    mb0: !open,
    mb4: open,
  });
  return (
    <div className={containerClassName}>
      <MetaInfoToggle onClick={onClick} label={label} />
      <div hidden={!open}>{children}</div>
    </div>
  );
};

export const createCollapsedBlockWithContent = (
  label: string,
  children: React.Element<any>
) => (props: { onClick: Function, open: boolean }) => (
  <CollapsedBlock label={label} open={props.open} onClick={props.onClick}>
    {children}
  </CollapsedBlock>
);

export default CollapsedBlock;



// WEBPACK FOOTER //
// ./src/components/ContentSection/CollapsedBlock.js